import React from 'react';
import { quickStats } from '../../data/salesContent';
export function StatsSection() {
  return <section className="border-y border-ink-line bg-ink-soft px-5 py-16 md:py-20" aria-label="Datos del sistema" data-id="element-189" data-mp="3ezsgsvdq6bg6">
      <div className="mx-auto max-w-6xl" data-id="element-190" data-mp="302rvpaq1heqo">
        <ul className="grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4" data-id="element-191" data-mp="30433rmqip8nl">
          {quickStats.map(s => <li key={s.label} className="flex flex-col items-center rounded-2xl border border-gold/25 bg-ink px-4 py-8 text-center md:py-10" data-id="element-192" data-mp="351bjlgo710lo">
              <span className="font-display text-6xl font-black leading-none text-gold md:text-7xl" data-id="element-193" data-mp="1kw65r4yce5x">{s.value}</span>
              <span className="mt-4 text-sm font-bold uppercase tracking-wider text-cream md:text-base" data-id="element-194" data-mp="3j1mb8lxbuj7w">{s.label}</span>
            </li>)}
        </ul>
        <p className="mt-12 text-center font-display text-2xl font-black uppercase text-cream md:text-4xl" data-id="element-195" data-mp="3nxurk2n9gign">
          Todo en un <span className="text-gold" data-id="element-196" data-mp="kauf09gkqbam">solo sistema.</span>
        </p>
      </div>
    </section>;
}